import { GroupBase, StylesConfig } from "react-select";

const ReactSelectStyle: StylesConfig<unknown, false, GroupBase<unknown>> = {
    container: (base: any) => ({
        ...base
        // padding: "0px",
        // margin: "0px"
    }),
    control: (base: any) => ({
        ...base,
        margin: "0px",
        padding: "0px",
        color: "red",
        height: "33px",
        minHeight: "33px"
    }),
    menu: (base: any) => ({
        ...base
        // margin: "0px",
        // padding: "0px",
        // color: "green",
        // height: "12px",
        // minHeight: "0px"
    }),
    menuList: (base: any) => ({
        ...base
        // margin: "0px",
        // padding: "0px",
        // color: "yellow",
        // height: "12px",
        // minHeight: "0px"
    }),
    option: (base: any) => ({
        ...base
        // backgroundColor: "pink",
        // height: "12px",
        // minHeight: "0px",
        // padding: "0px",
        // margin: "0px"
    }),
    singleValue: (base: any) => ({
        ...base,
        marginTop: "4px",
        marginBottom: "6px",
        marginLeft: "6px",
        padding: "0px"
    })
};

const ReactSelectStyleSmall: StylesConfig<unknown, false, GroupBase<unknown>> = {
    container: (base: any) => ({
        ...base,
        minWidth: "200px",
        maxWidth: "200px",
        // padding: "0px",
        // margin: "0px"
        
    }),
    control: (base: any) => ({
        ...base,
        
        margin: "0px",
        padding: "0px",
        color: "red",
        height: "27px",
        minHeight: "27px"
    }),
    menu: (base: any) => ({
        ...base,
        
        // margin: "0px",
        // padding: "0px",
        // color: "green",
        // height: "12px",
        // minHeight: "0px"
    }),
    menuList: (base: any) => ({
        ...base,
        // margin: "0px",
        // padding: "0px",
        // color: "yellow",
        // height: "12px",
        // minHeight: "0px",
        fontSize: "11px"

    }),
    option: (base: any) => ({
        ...base,
        // backgroundColor: "pink",
        // height: "12px",
        // minHeight: "0px",
        // padding: "0px",
        // margin: "0px"
        fontSize: "11px"
    }),
    singleValue: (base: any) => ({
        ...base,
        marginTop: "0px",
        marginBottom: "2px",
        marginLeft: "4px",
        padding: "0px",
        fontSize: "11px"
    })
};

export { ReactSelectStyle, ReactSelectStyleSmall };
